import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class WorkOrders_ds_get_operationcode_by_operationCodeIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { operationCodeId: number, fullTextSearch?: string }): 
  Promise<{ result: { Id?: number, Name?: string, Uom?: number } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.operationCodeId)) {
      $missingRequiredInParams.push('\'operationCodeId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      operationCodeId: number, fullTextSearch?: string    }) {
        if(isNil($inParams.operationCodeId)) {
          return true; 
        }
      return false;
    }
}
